import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      currentTeamsList: [],
      // {
      //   teamId: 1
      //   conference: 'AFC',
      //   division: 'North',
      //   name: 'Atlanta Falcons',
      // },
    }
  },
  mutations,
  actions,
  getters,
};